import data from "../../../Images/Data.png"
import marketing from "../../../Images/Marketing.png"
import trophy from "../../../Images/trophy.png"
import React from 'react'
import { Box, Typography, Container, Grid } from '@mui/material';
import { motion } from 'framer-motion';

const Content = () => {
  const features = [
    {
      icon: data,
      title: "Data Analysts",
      description: "Access clean, reliable data from any source—no engineers needed. Analyze more, wrangle less."
    },
    {
      icon: marketing,
      title: "Marketing & Growth Teams", 
      description: "Auto-sync CRM, ads, and analytics into one up-to-date view for faster, smarter decisions."
    },
    {
      icon: trophy,
      title: "Data Engineers & IT Teams",
      description: "Offload ETL to a no-code platform—govern data, monitor pipelines, and customize with ease."
    }
  ];

  return (
    <Box
      sx={{
        py: { xs: 6, md: 2 },
        px: { xs: 2, md: 4 },
        bgcolor: 'background.default',
      }}
    >
      <Container maxWidth="4xl">
        <Grid container spacing={{ xs: 4, md: 6 }} justifyContent="center">
          {features.map((feature, index) => (
            <Grid item xs={12} md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'start',
                    textAlign: 'start',
                    p: { xs: 3, md: 4 },
                    height: '100%',
                  }}
                >
                  {/* Icon */}
                  <Box
                    sx={{
                      mb: 3,
                      display: 'flex',
                      alignItems: 'start',
                      justifyContent: 'start',
                    }}
                  >
                    <img
                      src={feature.icon}
                      alt={feature.title}
                      style={{
                        width: '60px',
                        height: '60px',
                        objectFit: 'contain',
                      }}
                    />
                  </Box>

                  {/* Title */}
                  <Typography
                    variant="h5"
                    component="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { xs: '1.1rem', md: '1.3rem' },
                      mb: 2,
                      color: '#1565c0',
                      lineHeight: 1.3,
                    }}
                  >
                    {feature.title}
                  </Typography>

                  {/* Description */}
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: { xs: '0.95rem', md: '0.8rem' },
                      color: 'text.primary',
                      lineHeight: 1.6,
                      maxWidth: '350px',
                    }}
                  >
                    {feature.description}
                  </Typography>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  )
}

export default Content